export default "<p>\n  Redirecionando aguarde...\n</p>"